import React from 'react';
import { Direction, Column, TabContainer, Tab, TabItem, TabAction, TabContent } from '@scotia/canvas-react';
import AnimatedBadge from '../animated-badge/animated-badge';
import Summary from '../../components/summary';
import PendingProducts from '../../components/pending-products';

const constants = {
  tabs: {
    yourProducts: 'Tus productos',
    yourPendings: 'Tus pendientes',
  },
};

/* const YourPendingsTab = ({ badge }) =>
  badge > 0 ? (
    <AnimatedBadge value={badge} circleColor={'#7849B8'}>
      {constants.tabs.yourPendings}
    </AnimatedBadge>
  ) : (
    constants.tabs.yourPendings
  ); */

const ProductsTab = ({ loadProductsCallback }) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [pendingBadge, setPendingBadge] = React.useState(0);

  /* const updateBadgeWrapper = React.useCallback(async () => {
        try {
            const pendingProducts = await loadProductsCallback();

            setPendingBadge(Array.isArray(pendingProducts) ? pendingProducts.length : 0);

            return pendingProducts;
        } catch (error) {
            throw error;
        }
    }, [loadProductsCallback]); */

  return (
    <>
      <Direction>
        <Column xs={12} sm={12} md={12}>
          <TabContainer>
            <Tab>
              <TabItem>
                <TabAction isActive={activeTab === 0} onClick={() => setActiveTab(0)}>
                  {constants.tabs.yourProducts}
                </TabAction>
              </TabItem>
            </Tab>

            {/* <TabItem>
                            <TabAction
                                isActive={activeTab === 1}
                                onClick={() => setActiveTab(1)}>
                                    <YourPendingsTab badge={pendingBadge} />
                            </TabAction>
                        </TabItem> */}

            <TabContent isActive={activeTab === 0}>
              <Summary />
            </TabContent>

            {/* <TabContent isActive={activeTab === 1}>
                        <PendingProducts loadProductsCallback={updateBadgeWrapper} />
                    </TabContent> */}
          </TabContainer>
        </Column>
      </Direction>
    </>
  );
};
export default ProductsTab;
